

const Causer = ({ causer }) => {

    const { persona } = causer;
    // console.log(causer)
    // console.log(persona)
    return (
        <>
            <section className="py-2 px-4 border border-1 border-secondary rounded" style={{ width: "fit-content" }}>
                <h4 className="m-0">Causante</h4>
                <div className="d-flex gap-5">
                    <div className="d-flex gap-2">
                        <p className="m-0 fw-semibold text-primary">UsuarioID:</p><p className="m-0" >{persona.usuarioID}</p>
                    </div>
                    <div className="d-flex gap-2">
                        <p className="m-0 fw-semibold text-primary">Documento:</p><p className="m-0" >{persona.documento}</p>
                    </div>

                </div>
                <div className="d-flex gap-2">
                    <p className="m-0 fw-semibold text-primary">Nombre:</p><p className="m-0" >{persona.nombre}</p>
                </div>
                <div className="d-flex gap-5">
                    <div className="d-flex gap-2">
                        <p className="m-0 fw-semibold text-primary">Telefono:</p><p className="m-0" >{persona.celular}</p>
                    </div>
                    <div className="d-flex gap-2">
                        <p className="m-0 fw-semibold text-primary">Género:</p><p className="m-0" >{persona.genero}</p>
                    </div>
                </div>
                <div className="d-flex gap-2">
                        <p className="m-0 fw-semibold text-primary">Correo electronico:</p><p className="m-0" >{persona.correoElectronico}</p>
                    </div>
                    <div className="d-flex gap-2">
                        <p className="m-0 fw-semibold text-primary">Dirección:</p><p className="m-0" >{persona.direccion}</p>
                    </div>
                
            </section>
        </>
    );
}
export default Causer;